import React from 'react';
import EventCardSkeleton from '../EventCardSkeleton';

interface EventsListSkeletonProps {
  count?: number;
}

const EventsListSkeleton: React.FC<EventsListSkeletonProps> = ({ 
  count = 6 
}) => {
  return (
    <div className="z-10 w-full md:px-8 md:mx-auto md:max-w-[1200px]">
      {/* Page count skeleton */}
      <div className="z-10 ml-4 text-sm text-gray-500 pb-4 pt-6 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-24" />
      </div>
      
      {/* Events grid skeleton - matching the flex layout from EventsList */}
      <div className="flex flex-col md:flex-row gap-8 md:gap-5 justify-center w-full flex-wrap mb-8">
        {Array.from({ length: count }).map((_, index) => (
          <EventCardSkeleton key={index} />
        ))}
      </div>
      
      {/* Load More button skeleton */}
      <div className="flex justify-center">
        <div className="w-[125px] h-10 bg-gray-200 rounded animate-pulse self-center" />
      </div>
    </div>
  );
};

export default EventsListSkeleton;
